/* ==========================================================
   uhren4you – Produktseite v2 (10/2026): Reiter der Produktdetails
   Markup: sections/u4y-product-details.liquid · Styles: assets/u4y-pdp2.css
   - Klick auf einen Reiter scrollt weich zum Bereich ("Versand & Rückgabe" klappt dabei auf)
   - beim Scrollen wird der aktuelle Bereich markiert
   - die Leiste bleibt oben stehen, direkt unter dem (ein-/ausblendenden) Kopfbereich
   CI 10/2026: runde Lupe unten rechts im Hauptbild öffnet die Vollbild-Ansicht
   ========================================================== */
(function () {
  'use strict';
  if (window.u4yPdp2Loaded) return;
  window.u4yPdp2Loaded = true;

  function initTabs() {
    var nav = document.querySelector('.u4y-pd__nav');
    if (!nav || nav.dataset.u4yTabs) return;
    nav.dataset.u4yTabs = '1';
    var list = nav.querySelector('.u4y-pd__navlist');
    var tabs = Array.prototype.slice.call(nav.querySelectorAll('.u4y-pd__tab'));
    // fette Schrift des aktiven Reiters soll die Leiste nicht verschieben (Breite per CSS reserviert);
    // Reiter mit Kurzform fürs Handy (Usability v1, 31.10.2026): lange und kurze Beschriftung getrennt merken
    tabs.forEach(function (t) {
      var lg = t.querySelector('.u4y-pd__tab-long');
      var sh = t.querySelector('.u4y-pd__tab-short');
      t.setAttribute('data-label', (lg || t).textContent.trim());
      if (sh) t.setAttribute('data-label-short', sh.textContent.trim());
    });
    var targets = tabs.map(function (t) {
      return document.querySelector(t.getAttribute('href'));
    });
    var header = document.querySelector('.section-header');
    var current = -1;

    function headerOffset() {
      if (!header) return 0;
      var pos = getComputedStyle(header).position;
      if (pos !== 'sticky' && pos !== 'fixed') return 0;
      return Math.max(0, Math.round(header.getBoundingClientRect().bottom));
    }
    function setTop() {
      document.documentElement.style.setProperty('--u4y-pd-top', headerOffset() + 'px');
    }
    function setActive(i) {
      if (i === current) return;
      current = i;
      tabs.forEach(function (t, j) {
        t.classList.toggle('is-active', i === j);
        if (i === j) t.setAttribute('aria-current', 'true');
        else t.removeAttribute('aria-current');
      });
      var t = tabs[i];
      if (t && list && (t.offsetLeft < list.scrollLeft || t.offsetLeft + t.offsetWidth > list.scrollLeft + list.clientWidth)) {
        list.scrollTo({ left: Math.max(0, t.offsetLeft - 16), behavior: 'smooth' });
      }
    }
    function update() {
      setTop();
      var line = headerOffset() + nav.offsetHeight + 60;
      var idx = 0;
      targets.forEach(function (el, i) {
        if (el && el.getBoundingClientRect().top - line <= 0) idx = i;
      });
      // ganz unten angekommen: letzten sichtbaren Bereich markieren
      if (window.innerHeight + window.pageYOffset >= document.documentElement.scrollHeight - 4) {
        for (var k = targets.length - 1; k >= 0; k--) {
          if (targets[k] && targets[k].getBoundingClientRect().top < window.innerHeight) {
            idx = Math.max(idx, k);
            break;
          }
        }
      }
      setActive(idx);
    }

    var ticking = false;
    var settle;
    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(function () {
            ticking = false;
            update();
          });
        }
        clearTimeout(settle);
        settle = setTimeout(setTop, 300);
      },
      { passive: true }
    );
    window.addEventListener('resize', update);

    tabs.forEach(function (t, i) {
      t.addEventListener('click', function (e) {
        var el = targets[i];
        if (!el) return;
        e.preventDefault();
        var acc = el.querySelector('details.u4y-pd__acc--big');
        if (acc) acc.open = true;
        var top = el.getBoundingClientRect().top;
        // nach oben scrollen blendet den Kopfbereich wieder ein – dann auch seine Höhe abziehen
        var hdr = top < 0 && header ? header.offsetHeight : 0;
        var y = top + window.pageYOffset - nav.offsetHeight - hdr - 24;
        window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
        setActive(i);
        if (history.replaceState) history.replaceState(null, '', t.getAttribute('href'));
      });
    });
    update();
  }

  /* ---------- Lupe unten rechts im Hauptbild: öffnet die Vollbild-Ansicht (assets/u4y-gallery.js) ---------- */
  var ZOOM_LABEL = {
    de: 'Bild vergrößern',
    en: 'Enlarge image',
    fr: "Agrandir l'image",
    es: 'Ampliar imagen',
    it: "Ingrandisci l'immagine",
    sv: 'Förstora bilden',
    pl: 'Powiększ zdjęcie',
    nl: 'Afbeelding vergroten'
  };
  var ZOOM_ICON =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><circle cx="11" cy="11" r="6.5"/><path d="m20 20-4.4-4.4M11 8.2v5.6M8.2 11h5.6"/></svg>';

  function initZoomButton() {
    var lang = (document.documentElement.lang || 'de').slice(0, 2).toLowerCase();
    document.querySelectorAll('media-gallery').forEach(function (gallery) {
      var viewer = gallery.querySelector('slider-component[id^="GalleryViewer"]');
      if (!viewer || viewer.querySelector('.u4y-zoom-btn')) return;
      if (!gallery.querySelector('.product__media-list .product__media-toggle')) return;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'u4y-zoom-btn';
      btn.setAttribute('aria-label', ZOOM_LABEL[lang] || ZOOM_LABEL.en);
      btn.innerHTML = ZOOM_ICON;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var item =
          gallery.querySelector('.product__media-list .product__media-item.is-active') ||
          gallery.querySelector('.product__media-list .product__media-item');
        var toggle = item && item.querySelector('.product__media-toggle');
        if (toggle) toggle.click();
      });
      viewer.appendChild(btn);
    });
  }

  function init() {
    initTabs();
    initZoomButton();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();